module.exports = __webpack_public_path__ + "assets/img/71c22fcaae4a13fc744a8d54be72f5e6.svg";